import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import KauflandCredentialsSubSubTab from "./Credentials/KauflandCredentials";
import PlentyCredentialsSubSubTab from "../../Credentials/PlentyCredentials";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const KauflandCredentials = () => {
  const [kauflandSubTab, setKauflandSubTab] = useState(0);

  const handleKauflandSubTabChange = (event, newValue) => {
    setKauflandSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={kauflandSubTab}
              onChange={handleKauflandSubTabChange}
              aria-label="credentials tabs"
            >
              <Tab label="Kaufland Credentials" />
              <Tab label="Plenty Credentials" />
            </Tabs>
          </Box>

          {/* Kaufland Credentials Tab */}
          <TabPanel value={kauflandSubTab} index={0}>
            <KauflandCredentialsSubSubTab />
          </TabPanel>
          {/* Plenty Credentials Tab */}
          <TabPanel value={kauflandSubTab} index={1}>
            <PlentyCredentialsSubSubTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default KauflandCredentials;
